/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Unknownname2Inputs */

const zh_organizationsettings_unknownname2 = /** @type {(inputs: Organizationsettings_Unknownname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未设置`)
};

const en_organizationsettings_unknownname2 = /** @type {(inputs: Organizationsettings_Unknownname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed`)
};

const es_organizationsettings_unknownname2 = /** @type {(inputs: Organizationsettings_Unknownname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin nombre`)
};

/**
* | output |
* | --- |
* | "Unnamed" |
*
* @param {Organizationsettings_Unknownname2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_unknownname2 = /** @type {((inputs?: Organizationsettings_Unknownname2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Unknownname2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_unknownname2(inputs)
	if (locale === "en") return en_organizationsettings_unknownname2(inputs)
	return es_organizationsettings_unknownname2(inputs)
});
export { organizationsettings_unknownname2 as "organizationSettings_unknownName" }